import { useCallback, useEffect, useRef, useState } from 'react';

export interface Toast {
  message: string;
  type: 'success' | 'error';
}

/** The `admin-toast` pattern (InvoicePanel): one message at a time, cleared after 4 s. */
export function useToast(initial: Toast | null = null) {
  const [toast, setToast] = useState<Toast | null>(initial);
  const timer = useRef<number | undefined>(undefined);

  const show = useCallback((message: string, type: Toast['type'] = 'success') => {
    window.clearTimeout(timer.current);
    setToast({ message, type });
    timer.current = window.setTimeout(() => setToast(null), 4000);
  }, []);

  useEffect(() => {
    if (initial) timer.current = window.setTimeout(() => setToast(null), 4000);
    return () => window.clearTimeout(timer.current);
    // Only the first render's toast is armed here; later ones go through show().
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { toast, show };
}

export function ToastView({ toast }: { toast: Toast | null }) {
  return toast ? <div className={`admin-toast ${toast.type}`} role="status">{toast.message}</div> : null;
}
